import autosizeInput from './autosize-input'

$.fn.IncrementField = function() {
  let self = this
  if (self.data('instance')) {
    return self
  }
  self.el = {
    container: $('<div class="increment-field"></div>'),
    btn_plus: $('<button>+</button>'),
    btn_minus: $('<button>-</button>'),
  }
  self.min = parseInt(self.attr("min"))
  self.max = parseInt(self.attr("max"))

  self.plus = function() {
    let value = parseInt(self.val())
    if (isNaN(value)) {
      value = 0
    }
    value += 1
    self.val(value).change()
  }

  self.minus = function() {
    let value = parseInt(self.val())
    if (isNaN(value)) {
      value = 0
    }
    value -= 1
    self.val(value).change()
  }

  self.validate = function() {
    let value = parseInt(self.val())
    if (isNaN(value)) {
      value = 1
    }
    if (value === self.min) {
      // bypass
    } else if (!value || value == undefined) {
      value = 1
    }
    if (value < self.min) {
      value = self.min
    }
    if (value > self.max) {
      value = self.max
    }
    self.val(value)
  }

  return function() {
    self.wrap(self.el.container)
    self.before(self.el.btn_minus)
    self.after(self.el.btn_plus)
    self.el.btn_plus.on('click', function(e) {
      e.preventDefault()
      self.plus()
      if (e.originalEvent.detail === 1) {
        $(this).blur()
      }
    })
    self.el.btn_minus.on('click', function(e) {
      e.preventDefault()
      self.minus()
      if (e.originalEvent.detail === 1) {
        $(this).blur()
      }
    })
    self.on('change', self.validate)
    autosizeInput(self.get(0))
    self.data('instance', self)
    return self
  }()
}
